import { render, staticRenderFns } from "./integralpage.vue?vue&type=template&id=7ddb2204&scoped=true"
import script from "./integralpage.vue?vue&type=script&lang=js"
export * from "./integralpage.vue?vue&type=script&lang=js"
import style0 from "./integralpage.vue?vue&type=style&index=0&id=7ddb2204&prod&lang=scss&scoped=true"
import style1 from "./integralpage.vue?vue&type=style&index=1&id=7ddb2204&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb2204",
  null
  
)

export default component.exports